import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import { useDropzone } from "react-dropzone";
import AppBars from "../AppBar/AppBar";
import Listitems from "../ListItems/ListItems";
import { useNavigate, useParams } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob"; // Azure Blob Storage SDK
// import YourChildComponent from "./YourChildComponent";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress
import { sasToken, containerName } from "../Global";
import { DrawerHeader, Drawer, GlobalUrl} from "../Global";
import Cookies from "js-cookie";
import axios from "axios";

export default function FileUpload() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(!isSmallScreen); // Closed by default on small screens
  // const [fileTypePath, setFileTypePath] = React.useState();
  const [files, setFile] = React.useState(null);
  const [uploadedFiles, setUploadedFiles] = React.useState(null);
  const [error, setError] = React.useState(""); // Error state to show if the wrong file type is uploaded
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [fileRemoveLoading, setFileRemoveLoading] = React.useState(false);
  const [datasetName, setDatasetName] = React.useState(null);

  const storageAccountName = "dspkstorage"; // Your Azure storage account name
  const Params = useParams();

  const fetchData = async () => {
    try {
      const token = Cookies.get("sFrontToken");
      if (!token) {
        throw new Error("Access token is not available");
      }

      const response = await axios({
        method: "get",
        url: `${GlobalUrl}/doc/get-dataset-files-list/${Params.datasetId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      setUploadedFiles(response.data.data.file_urls);
      setDatasetName(response.data.data.dataset_name)
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleNavigation = (text) => {
    if (text === "Private Collections") {
      navigate("/dataset/list/private");
    }
    if (text === 'Shared Collections') {
      navigate('/dataset/list/shared');
    }
    if (text === "Collections") {
      navigate("/dataset/list/public");
    }
    if (text === "Upload New Dataset") {
      navigate("/upload");
    }
    if (text === "Notes") {
      navigate("/dataset/Notes");
    }
  };

  
  const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
      
        const invalidFiles = acceptedFiles.filter(
          (file) => file.type !== "application/pdf" & file.type !== "text/csv"
        );
        if (invalidFiles.length > 0) {
          setError("Please upload CSV or PDF files.");
        } else {
          if(files?.length>0){
            setFile([...files, ...acceptedFiles]); 
          }else{
            setFile(acceptedFiles); 
          }
          // For PDFs, store all selected files
          setError("");
        }
    },
  });

  const generateUniqueFileName = (originalFileName) => {
    const timestamp = new Date().getTime();
    const fileExtension = originalFileName.split('.').pop();
    const nameWithoutExtension = originalFileName.split('.').slice(0, -1).join('.');
    return `${nameWithoutExtension}_${timestamp}.${fileExtension}`;
  };
  
  // Usage
  // Function to handle file upload to Azure
  // Handle file upload to Azure
  const handleUpload = async () => {
    if (!files || (Array.isArray(files) && files.length === 0)) {
      alert("Please select a file first!");
      return;
    }

    try {
      setLoading(true);
      // Create BlobServiceClient with the SAS token
      const blobServiceClient = new BlobServiceClient(
        `https://dspkstorage.blob.core.windows.net/?${sasToken}`
      );

      // Get the container client
      const containerClient =
        blobServiceClient.getContainerClient(containerName);

      const fileUrls = [];
      if (Array.isArray(files)) {
        // Array to hold URLs of all uploaded files
        

        // Handle multiple files (for PDFs)
        for (let i = 0; i < files.length; i++) {
          const currentFile = files[i];
          const blockBlobClient = containerClient.getBlockBlobClient(
            generateUniqueFileName(currentFile.name)
          );
          const uploadBlobResponse = await blockBlobClient.uploadBrowserData(
            currentFile
          );


          // Construct the file URL and add to fileUrls array
          // const fileUrl = blockBlobClient.url.split("?")[0]; // Only take the base URL without query parameters
          const fileUrl = decodeURIComponent(blockBlobClient.url.split("?")[0]);
          fileUrls.push(fileUrl);
        }

        // Join the URLs for display or further use
        // console.log("All file URLs:", fileUrls);

        setLoading(false);
      } else {
        // Handle single file (for CSV or single PDF)
        const blockBlobClient = containerClient.getBlockBlobClient(encodeURIComponent(files.name).replace(/%20/g, "_").replace(/[()]/g, ""));
        const uploadBlobResponse = await blockBlobClient.uploadBrowserData(
          files
        );
        // console.log(`Upload successful: ${uploadBlobResponse.requestId}`);

        // Construct the file URL
        const fileUrl = blockBlobClient.url.split("?")[0]; // Only take the base URL without query parameters
        fileUrls.push(fileUrl);
        setLoading(false);
      }
      uploadToDataset(fileUrls)
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("File upload failed. Please try again.");
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setOpen(!isSmallScreen); // Update drawer state when screen size changes
  }, [isSmallScreen]);

  const removeDatasetFiles = async (index)=> {
    const token = Cookies.get("sFrontToken");
    const body = {
        dataset_id: Params.datasetId,
        file_urls: [uploadedFiles[index]],
      };
    try {
        let response;
  
        // Check if file is an array (for PDFs)
        // if (Array.isArray(file) && file[0].type.includes("pdf")) {
        setFileRemoveLoading(true)
        response = await axios.post(
          `${GlobalUrl}/doc/remove-dataset-files`,
          {
            ...body,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response && response.status === 200) {
            setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index))
        }else if (response && response.status !== 200) {
            setErrorMessage(response.data.message);
        }
        setFileRemoveLoading(false)
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage("An unexpected error occurred.");
        }
        setFileRemoveLoading(false)
      } finally {
        setFileRemoveLoading(false);
      }

  }

  const uploadToDataset = async (fileUrls) => {
    const token = Cookies.get("sFrontToken");
    const body = {
      dataset_id: Params.datasetId,
      file_urls: fileUrls,
    };

    setLoading(true);
    setErrorMessage("");

    try {
      let response;

      // Check if file is an array (for PDFs)
      // if (Array.isArray(file) && file[0].type.includes("pdf")) {
      response = await axios.post(
        `${GlobalUrl}/doc/add-dataset-files`,
        {
          ...body,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response && response.status === 200) {
        if(response.data.task_id){
          navigate(`/dataset/upload/${response.data.task_id}`);
        }
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBars setOpen={setOpen} open={open} />

      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <Listitems handleNavigation={handleNavigation} open={open} />
      </Drawer>
    
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
          backgroundColor: "#EEEEEE",
          minHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" }, // Adjust based on header height
        }}
      >
        <DrawerHeader />
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Responsive font size
          }}
        >
          Dataset Name: { datasetName || "N/A"}
        </Typography>
          <>
            <Box
              {...getRootProps()}
              sx={{
                border: "2px dashed #ccc",
                padding: { xs: 3, sm: 4, md: 6 }, // Responsive padding for box
                textAlign: "center",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
                cursor: "pointer",
                minHeight: { xs: "150px", sm: "200px" }, // Responsive minHeight
              }}
            >
              <input {...getInputProps()} />

              <Typography variant="subtitle1">
                Drag and drop files here, or click to select
              </Typography>
            </Box>
            
            {files?.length > 0 ? (
              <ul>
                {files.map((f, index) => (
                  <li key={index}>
                    {index + 1}. {f.name}{" "}
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={() => setFile((prevFiles) => prevFiles.filter((_, i) => i !== index))}
                    >
                      Remove
                    </Button>
                  </li>
                ))}
              </ul>
            ) : (
              <></>
            )}


            {/* Display error message if invalid file type is uploaded */}
            {error && (
              <Typography color="error" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}

            {/* Upload Button */}
            {loading ? (
              <CircularProgress />
            ) : (
              <Box sx={{ mt: { xs: 1, sm: 2 } }}>
                {" "}
                {/* Responsive margin */}
                <Button
                  variant="contained"
                  disabled={ !files}
                  onClick={handleUpload}
                >
                  Upload File
                </Button>
              </Box>
            )}
            <p style={{color: "yellow", backgroundColor:"black"}}>Note: File you are trying to upload needs proper column headers (For CSV)</p>
          </>

        <div>Uploaded Files</div>
        {uploadedFiles?.length > 0 ? (
            <ul>
            {uploadedFiles.map((url, index) => (
                <li key={index}>
                {index + 1}. {url.split("/").pop()}{" "}
                <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={() => removeDatasetFiles(index)}
                >
                    Remove
                </Button>
                </li>
            ))}
            </ul>
        ) : (
          <Typography>
            <CircularProgress />
          </Typography>
        )}
        {errorMessage && (
            <Typography color="error" sx={{ mt: 2 }}>
            {errorMessage}
            </Typography>
        )}
        {fileRemoveLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <></>)
        }
      </Box>
    </Box>
  );
}
